export const DATA_CONSENT_INPUT_NAME = 'data-consent'
export const FOUR_YEAR_COLLEGE_INPUT_NAME = 'four-year-college'
export const FEDERAL_WORK_STUDY_INPUT_NAME = 'federal-work-study'
export const ACKNOWLEDGEMENTS_INPUT_NAMES = [
  DATA_CONSENT_INPUT_NAME,
  FOUR_YEAR_COLLEGE_INPUT_NAME,
  FEDERAL_WORK_STUDY_INPUT_NAME,
]

export type CAWConsentDetails = {
  acknowledgements: (typeof ACKNOWLEDGEMENTS_INPUT_NAMES)[number][]
}
